var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrashCan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.434,
    height: 14.815,
    viewBox: "0 0 13.434 14.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-trash-2",
    "data-name": "Icon feather-trash-2",
    transform: "translate(-4 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_364",
    "data-name": "Caminho 364",
    d: "M4.5,9H16.934",
    transform: "translate(0 -3.237)",
    fill: "none",
    stroke: "#b10000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_365",
    "data-name": "Caminho 365",
    d: "M17.171,5.763v9.671a1.382,1.382,0,0,1-1.382,1.382H8.882A1.382,1.382,0,0,1,7.5,15.434V5.763m2.072,0V4.382A1.382,1.382,0,0,1,10.954,3h2.763A1.382,1.382,0,0,1,15.1,4.382V5.763",
    transform: "translate(-1.618 0)",
    fill: "none",
    stroke: "#b10000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_366",
    "data-name": "Caminho 366",
    d: "M15,16.5v4.145",
    transform: "translate(-5.665 -7.283)",
    fill: "none",
    stroke: "#b10000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_367",
    "data-name": "Caminho 367",
    d: "M21,16.5v4.145",
    transform: "translate(-8.902 -7.283)",
    fill: "none",
    stroke: "#b10000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashCan);
export default __webpack_public_path__ + "static/media/IconTrashCan.6047ae5ef9422d23cfed1d9b3faefda2.svg";
export { ForwardRef as ReactComponent };